var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"all","width":"100%","position":"bottom center"}}),(_vm.isLoading)?_c('div',[_c('fingerprint-spinner',{staticClass:"spinner",attrs:{"animation-duration":1500,"size":150,"color":"#136a8a"}})],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }